import {AddressFormItemType, AddressType} from 'desktop/types/addressType';

export const SHIPPING_METHODS_CODES = {
    EXPEDITED: 'glassescourier_glassescourier',
    EXPRESS: 'glassesfedex_glassesfedex',
    NEXT_DAY: 'twodaydelivery_twodaydelivery',
    STANDARD: 'flatrate_flatrate',
};
export const TOOLTIP_NAME = 'Digicert';

export const INITIAL_FORM_VALUES: AddressType = {
    address: {error: false, success: false, value: ''},
    city: {error: false, success: false, value: ''},
    country: {error: false, success: false, value: 'US'},
    email: {error: false, success: false, value: ''},
    firstName: {error: false, success: false, value: ''},
    lastName: {error: false, success: false, value: ''},
    other: {error: false, success: false, value: ''},
    phone: {error: false, success: false, value: ''},
    postal: {error: false, success: false, value: ''},
    regionID: {error: false, success: false, value: ''},
    state: {error: false, success: false, value: '0'},
};

export const defaultAddress = Object.entries(INITIAL_FORM_VALUES).reduce(
    (acc, [key, data]) => ({
        ...acc,
        [key]: data.value,
    }),
    {} as AddressFormItemType,
);

export const TWO_DAYS_MODAL_TOMORROW = {
    FIRST: 'The items in your cart qualify for next-day shipping! You can get your order by tomorrow with faster production and faster delivery, plus a money-back guarantee on the shipping charges if it doesn’t arrive on time.',
    SECOND: 'Orders must be placed from Monday to Friday before 12PM ET to be eligible. Please note, during the holiday season & peak shopping days, shipping delays may occur.',
};

export const TWO_DAYS_MODAL_OTHER = {
    FIRST: 'The items in your cart qualify for next-day shipping! You can get your order in up to 2 business days with faster production and faster delivery, plus a money-back guarantee on the shipping charges if it doesn’t arrive on time.',
    SECOND: 'Example: If you place an order on Mon. after 12 PM ET, it will arrive by Wednesday at the latest. Please note, during the holiday season & peak shopping days, shipping delays may occur.',
};
